export default "__VITE_PUBLIC_ASSET__a10dc4d8__"